(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.dialog = document.getElementById('cart-drawer');
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('quantity-input').forEach((quantityInput) => {
      quantityInput.addEventListener('change', this.onQuantityChange.bind(this));
    });
  }

  onQuantityChange(event) {
    const input = event.target;
    const itemIndex = input.dataset.index;
    const quantity = parseInt(input.value);

    const body = JSON.stringify({
      line: itemIndex,
      quantity: quantity,
      sections: ['cart-drawer']
    });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body
    })
    .then(response => response.json())
    .then(data => {
      this.updateCartDrawer(data);
    });
  }

  updateCartDrawer(cart) {
    // Update cart count
    document.querySelectorAll('.header__cart-count').forEach((element) => {
      element.textContent = cart.item_count;
    });

    // Update cart totals
    this.querySelector('.totals__subtotal-value').innerHTML = 
      this.formatMoney(cart.total_price);
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }
}

customElements.define('cart-drawer-items', CartDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["off-canvas-menu"] && !Shopify.designMode) return;
  try {
    class OffCanvasMenu {
    constructor() {
      this.dialog = document.getElementById('off-canvas-menu');
      this.bindEvents();
    }

    bindEvents() {
      this.dialog.querySelectorAll('.off-canvas-menu__submenu-toggle').forEach(button => {
        button.addEventListener('click', this.toggleSubmenu.bind(this));
      });
    }

    toggleSubmenu(event) {
      const button = event.currentTarget;
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !isExpanded);
    }
  }

  new OffCanvasMenu();
  } catch(e) { console.error(e); }
})();

})();
